import type { RectangleShape } from "@gettactic/map-builder/src/types";
import React from "react";
import { buildWorldShapeTransform } from "../shapeTransform";

export interface RectangleSvgProps {
  shape: RectangleShape;
}

export const RectangleSvg: React.FC<RectangleSvgProps> = ({ shape }) => {
  const maxRadius = Math.min(shape.width, shape.height) / 2;
  const radius = Math.min(shape.cornerRadius || 0, maxRadius);
  return (
    <rect
      x={shape.x}
      y={shape.y}
      width={shape.width}
      height={shape.height}
      fill={shape.noFill ? "none" : shape.color || "#000000"}
      stroke={shape.stroke || "none"}
      strokeWidth={shape.strokeWidth || 0}
      rx={radius}
      transform={buildWorldShapeTransform(shape)}
    />
  );
};
